import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { T } from "../../lib/testids";

/**
 * Responsive (Sprint 12 móvil): en escritorio (lg+) esto es exactamente el
 * shell de siempre — el sidebar nunca deja de ser estático ahí. Por debajo
 * de `lg`, el sidebar se vuelve un panel que se abre con el botón del
 * TopBar y se cierra solo (con el fondo oscuro o al elegir un link) — nunca
 * comparte ancho con el contenido, que es lo que comprimía toda la pantalla.
 */
export default function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div
      data-testid={T.appShell}
      className="min-h-screen lg:flex bg-[#0d1321] text-zinc-100"
    >
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && (
        <div
          data-testid={T.sidebarBackdrop}
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 z-40 bg-black/60 lg:hidden"
        />
      )}
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar onMenuClick={() => setSidebarOpen((v) => !v)} />
        <main className="flex-1 overflow-x-hidden overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
